/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { proposalsGetApiV3ProposalsProposalId } from "../../funcs/proposalsGetApiV3ProposalsProposalId.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3ProposalsProposalIdRequest$inboundSchema,
};

export const tool$proposalsGetApiV3ProposalsProposalId: ToolDefinition<
  typeof args
> = {
  name: "proposals-get-api-v3-proposals-proposal-id",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await proposalsGetApiV3ProposalsProposalId(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
